
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product_article"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product_sl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_nid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_mobile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoice_no"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trailUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"product_article"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product_article"}}},{"kind":"Argument","name":{"kind":"Name","value":"product_sl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product_sl"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_nid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_nid"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_mobile"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_address"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"remarks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoice_no"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoice_no"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_article"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_sl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_nid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_mobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remarks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invoice_no"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":786}};
    doc.loc.source = {"body":"mutation (\r\n  $id: ID!\r\n  $product_article: String\r\n  $product_sl: String\r\n  $customer_nid: String\r\n  $customer_name: String\r\n  $customer_mobile: String\r\n  $customer_address: String\r\n  $status: String\r\n  $remarks: String\r\n  $invoice_no:String\r\n) {\r\n    trailUpdate(\r\n    id:$id\r\n    product_article: $product_article\r\n    product_sl: $product_sl\r\n    customer_nid: $customer_nid\r\n    customer_name: $customer_name\r\n    customer_mobile: $customer_mobile\r\n    customer_address: $customer_address\r\n    status: $status\r\n    remarks: $remarks\r\n    invoice_no: $invoice_no\r\n    ){\r\n      id\r\n      product_article\r\n      product_sl\r\n      customer_nid\r\n      customer_name\r\n      customer_mobile\r\n      customer_address\r\n      agreed\r\n      status\r\n      remarks\r\n      invoice_no\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
